// components/Footer.js
import React from 'react';
import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';
import { Divider } from 'primereact/divider';

const Footer = () => {
  return (
    <footer className="text-white p-4 mt-4 bg-primary" >
      <div className="grid">
        <div className="col-12 md:col-4">
          <h3 className='text-white'>Dream India School Tiruvuru</h3>
          <p>D.No.27-13-2, Rajupeta, Tiruvuru, NTR District - 521235.</p>
          <p>Phone: 1800 891 1256, 8886421212, 8886521212</p>
        </div>
        <div className="col-12 md:col-4">
          <h3 className='text-white'>Quick Links</h3>
          <ul className="list-none p-0">
            <li ><Link style={{color:'white', textDecoration:'none'}} to="/privacy">Privacy Policy</Link></li>
            <li><Link style={{color:'white', textDecoration:'none'}} to="/terms">Terms of Service</Link></li>
          </ul>
        </div>
        <div className="col-12 md:col-4">
          <h3 className='text-white'>Social Media</h3>
          <div>
            <Button icon="pi pi-facebook" className="p-button-rounded p-button-text mr-2 text-white" onClick={() => window.open('https://www.facebook.com/p/Dream-India-School-Tiruvuru-61555301981678/')} />
            <Button icon="pi pi-instagram" className="p-button-rounded p-button-text mr-2 text-white" onClick={() => window.open('https://www.instagram.com/dreamindiaschooltiruvuru/')} />
            <Button icon="pi pi-twitter" className="p-button-rounded p-button-text text-white" onClick={() => window.open('https://x.com/DlSTRVR')} />
          </div>
        </div>
      </div>
      <Divider className="my-2" />
      <p className="text-center">&copy; 2025 Dream India School. All rights reserved.</p>
    </footer>
  );
};

export default Footer;